import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {Outsourced} from "../../Outsourced";
import {OutsourcedXWaysSymbol} from "../../reels/symbols/XWaysSymbol";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";


/**
 * Created by jonas on 2022-01-12.
 */

export class RevealXWays implements SimplePresentation {

    name:string = "RevealXWays";

    constructor() {
    }

    shouldRun():boolean {
        return this.getXWaysSymbols().length > 0;
    }

    private getXWaysSymbols():OutsourcedXWaysSymbol[] {
        return <OutsourcedXWaysSymbol[]>Outsourced.reelView.getAllSymbols().filter((sym) => sym.symbolName == "XW");
    }

    start(controller:SimplePresentationRunnerController):void {
        const isQuickStop = Outsourced.apiPlugin.settings.get(APISetting.FAST_SPIN);
        const tl = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish()
            }
        })

        if (isQuickStop)
            tl.add(() => {tl.timeScale(1.5)});

        tl.add(() => {controller.setSkipCallback(() => {tl.seek("End", false)})}, "<")

        tl.add(() => {}, '>0.25')

        const symbols = Outsourced.reelView.getAllSymbols();
        let firstXWays = true;
        for (let reel= 0; reel < 4; reel++) {
            for (let row = 0; row < 4; row++) {
                const sym = symbols[reel * 4 + row];
                if (sym instanceof OutsourcedXWaysSymbol && !sym.hasRevealed) {
                    tl.add(sym.xWaysReveal(Outsourced.model.data.xWaysSymbol,
                                           Outsourced.model.actualSymbolSizes[reel][row]),
                           firstXWays ? "" : '<0.25');
                    tl.add(Outsourced.soundPlayer.playSoundBased(Outsourced.model.data.xWaysSymbol == "BL"
                                                                     ? "xWaysRevealDead"
                                                                     : "xWaysReveal"), '<')
                    firstXWays = false;
                }
            }
        }
        tl.add(() => {Outsourced.reelView.updateWays(Outsourced.model.postXwaysWays(), false)}, '<');


        tl.add(() => {}, '>0.5');

        if (isQuickStop)
            tl.add(() => {tl.timeScale(1)});

        tl.addLabel("End")
    }
}
